import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';

const DashboardLayout = ({ children }) => {
  // Seuil pour considérer l'écran comme "étroit" (tablette/petit laptop)
  const NARROW_SCREEN_THRESHOLD = 1280;
  const MOBILE_THRESHOLD = 768;

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Par défaut : ouvert si écran large, fermé si étroit
    return window.innerWidth >= NARROW_SCREEN_THRESHOLD;
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_THRESHOLD);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width < MOBILE_THRESHOLD;
      const narrow = width < NARROW_SCREEN_THRESHOLD;

      setIsMobile(mobile);

      // Auto-fermer la sidebar quand l'écran devient étroit
      if (narrow && !mobile) {
        setSidebarOpen(false);
      }
      // Fermer complètement sur mobile
      if (mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} isMobile={isMobile} onToggle={toggleSidebar} />

      {/* Main content wrapper */}
      <div className={`min-h-screen transition-all duration-300 ease-in-out ${sidebarOpen && !isMobile ? 'ml-64' : ''}`}>
        {/* Top bar - visible sur mobile ET desktop quand sidebar fermée */}
        <div className={`fixed top-0 right-0 bg-white shadow-sm border-b border-gray-200 z-30 transition-all duration-300 ${
          sidebarOpen && !isMobile ? 'left-64' : 'left-0'
        }`}>
          <div className="px-4 h-16 flex items-center justify-between">
            {/* Bouton Menu stylisé */}
            <button
              onClick={toggleSidebar}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm flex items-center gap-2"
              title={sidebarOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {sidebarOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
              <span>Menu</span>
            </button>

            {/* Logo complet - visible quand sidebar fermée (h-14 = 56px) */}
            {!sidebarOpen && (
              <div className="flex items-center space-x-2 absolute left-1/2 transform -translate-x-1/2">
                <img
                  src="/logo-boaz-housing.png"
                  alt="Boaz-Housing"
                  className="h-14 w-auto object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'inline';
                  }}
                />
                <span className="font-semibold text-gray-900 text-xl" style={{display: 'none'}}>Boaz-Housing</span>
              </div>
            )}

            <div className="w-20"></div> {/* Spacer pour équilibrer */}
          </div>
        </div>

        {/* Page content - padding augmenté pour éviter chevauchement */}
        <main className="min-h-screen pt-20">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;